import { Capability } from '../Capability';

type UserType = {
  Capability: typeof Capability;
};

const User: UserType = {
  Capability,
};

export { User };
